<span *ngIf="!clickable" fromTo [from]="from" [to]="to" [fromColor]="fromColor" class="{{fromToClass}}"></span>

<span *ngIf="clickable" class="row {{rowClass}}">
  <span fromTo [from]="from" [to]="to" [fromColor]="fromColor" class="col {{fromToClass}}"></span>
  <mat-icon [inlineSVG]="iconPath" class="col {{iconClass}}"></mat-icon>
</span>
